import { useLocation, useParams } from "react-router-dom";
import { ClienteCardPageGeral } from "../../../Components/CardsPages/Geral/Cliente";
import { ClientePageProvider } from "../../../Context/ClientePage";

export default function Clientes() {
    const contaID = useParams<{ idConta: string }>().idConta;
    const modulo = useLocation().pathname.split("/")[1];

    return (
        <ClientePageProvider
            ID_CONTA={Number.parseInt(contaID)}
            modulo={modulo}
        >
            <div className="container-fluid">
                <ClienteCardPageGeral idConta={Number.parseInt(contaID)} />
            </div>
        </ClientePageProvider>
    );
}
